// extracted by mini-css-extract-plugin
export var alternate = "_1w-j";
export var black = "_1w-6";
export var blue = "_1w-f";
export var blueLight = "_1w-e";
export var brand = "_1w-8";
export var darkMode = "_1w-b";
export var error = "_1w-a";
export var gray = "_1w-5";
export var grayBlue = "_1w-d";
export var iconWrapper = "_1w-3";
export var inactive = "_1w-7";
export var indigo = "_1w-g";
export var orange = "_1w-i";
export var pink = "_1w-h";
export var primary = "_1w-0";
export var purple = "_1w-9";
export var success = "_1w-4";
export var warning = "_1w-c";
export var white = "_1w-1";
export var whiteSuccess = "_1w-2";